import React from "react";
import styles from "./sobre_mim_robin_tattooart.module.scss";
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const Sobre_mim_robin_tattooart: React.FC = () => {

    return (
        <div className={styles.sobre_mim_robin_tattooart}>
            {/* HEADER */}
            <div className={styles.header}>
                <Link to="/robin_tattooart" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1 className="mb-0">Sobre mim</h1>
            </div>

            {/* CONTEÚDO */}
            <div className={styles.content}>
                <h2>Robson Izael</h2>
                <p>

                    Sou Robson Izael, artista cursado com 3 anos de experiência na área e mais de 8 cursos concluídos, sempre em busca de evolução e aperfeiçoamento.
                    Ao longo da minha trajetória, tive a honra de ser premiado em convenções mais de uma vez, reconhecimento que reforça minha dedicação e amor pela arte.
                </p>
                <p>
                    Sou especialista em realismo preto e cinza, um estilo que me permite expressar emoção, profundidade e detalhes únicos em cada trabalho.
                    Minha missão é transformar ideias em arte, eternizando histórias e sentimentos através da pele.
                </p>
            </div>

            {/* FOOTER */}
            <div className={styles.footer}>
                <div className={styles.divSocials}>


                    <a href="https://wa.me/5516992524152?text=Olá, vim pelo link na bio e gostaria de mais informações..." target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><WhatsappIcon height="30" color="#ffffff" /></div>
                            <span>WhatsApp</span>
                        </div>
                    </a>
                    <a href="https://maps.app.goo.gl/NLuVHyzeQn2xU44a8" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><MapsIcon height="30" color="#ffffff" /></div>
                            <span>Localização</span>
                        </div>
                    </a>
                    <a href="https://www.instagram.com/robin_tattooart?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><InstagramIcon height="26" color="#ffffff" /></div>
                            <span>Instagram</span>
                        </div>
                    </a>
                </div>
                <div className={styles.signature}>
                    Desenvolvido por{" "}
                    <a href="https://www.linksvibe.com.br" target="_blank" rel="noreferrer">
                        Links Vibe
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Sobre_mim_robin_tattooart;
